module.exports = __webpack_public_path__ + "d.no1.fc6520b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d.no1.jpg
// module id = j2jn
// module chunks = 0